import React, { FC } from "react";

import classNames from "classnames";
import styled from "@emotion/styled";

export interface TextareaProps
  extends React.DetailedHTMLProps<
    React.TextareaHTMLAttributes<HTMLTextAreaElement>,
    HTMLTextAreaElement
  > {
  id: string;
  dark?: string;
  label?: string;
  error?: string;
}

const Textarea: FC<TextareaProps> = ({
  id,
  dark,
  label,
  error,
  className,
  ...props
}) => {
  return (
    <TextareaWrapper>
      {label && (
        <label
          htmlFor={id}
          className={classNames("p2", { [dark]: dark })}
        >
          {label}
        </label>
      )}
      <TextareaOverride
        id={id}
        className={classNames(className, { [dark]: dark })}
        {...props}
      />
      {error && <TextareaError>{error}</TextareaError>}
    </TextareaWrapper>
  );
};

const TextareaWrapper = styled.div`
  width: 100%;
`;

const TextareaOverride = styled.textarea`
  margin-bottom: 0 !important;
`;

const TextareaError = styled.span`
  display: block;
  color: #e31c79;
  margin-top: 0.5rem;
  font-family: "Clan news", sans-serif;
`;

export default Textarea;
